export default class ShipTypeRepoStatic {
  constructor() {
    //console.log("Construyendo ShipTypeRepoStatic");
  }

  // eslint-disable-next-line
  getRangesForTypeShipType(ref, callback) {
    // console.log("ShipTypeRepoStatic-getRangesForTypeShipType", ref)
    const obj = {
      DWTMax: 100000,
      DWTMin: 15000,
      Ymax: 4,
      Ymin: 3,
    };
    callback(ref, obj);

    const obj2 = {
      DWTMax: 200000,
      DWTMin: 100000,
      Ymax: 6,
      Ymin: 4,
    };
    callback(ref, obj2);
  }
}
